import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { StateType } from 'domain/types/base/base';
import { CampanhaPedidoResgateService } from 'domain/services/_carteira/campanhaPedidoResgate/campanhaPedidoResgateService';
import { PagedListRequest } from 'domain/types/global/pagedListRequest';
import { CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA, CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA, CAMPANHARESGATE_APROVAR, CAMPANHARESGATE_REPROVAR, REMOVE_RESGATE, RESET_RESGATES_PAGAR, SET_RESGATES_PAGAR } from 'domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgate';
import { PagedListResponse } from 'domain/types/global/pagedListResponse';
import { CampanhaPedidoResgateResponse } from 'domain/types/_carteira/campanhaPedidoResgate/campanhaPedidoResgateResponse';
import { PedidoResgateService } from 'domain/services/_carteira/pedidoResgate/pedidoResgateService';
import { AppThunk, DispatchPaged, DispatchPagedReset } from 'base/src/utils/reducerUtil';
import { PremiacaoResponse } from 'domain/types/_carteira/premiacao/premiacaoResponse';

import { TFunction } from 'i18next';

const _CampanhaPedidoResgateService = new CampanhaPedidoResgateService();
const _PedidoResgateService = new PedidoResgateService();

export function GetSolicitadosByCampanha(campanhaId: number[], request: PagedListRequest<CampanhaPedidoResgateResponse>, t: TFunction): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA, DispatchType.LOADING, t("Carregando"), StateType.Local))

        request.data = { CampanhaID: campanhaId } as CampanhaPedidoResgateResponse;

        const asyncResponse = await _CampanhaPedidoResgateService.GetSolicitadosByCampanha(request);
        if (ResponseValid(asyncResponse)) {
            const paged = (asyncResponse as PagedListResponse<CampanhaPedidoResgateResponse>)
            dispatch(DispatchPaged<CampanhaPedidoResgateResponse>(CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA, request, paged))
        } else {
            dispatch(DispatchLoading(CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA, DispatchType.ERROR, t("Erro"), StateType.Local))
        }
    }
}

export function ResetSolicitadosByCampanha(request: PagedListRequest<CampanhaPedidoResgateResponse>, take: number): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchPagedReset<CampanhaPedidoResgateResponse>(CAMPANHA_PEDIDORESGATE_GET_BY_CAMPANHA, request, take))
    }
}

export function GetSolicitadosAprovadosByCampanha(campanhaId: number[], request: PagedListRequest<CampanhaPedidoResgateResponse>, t: TFunction): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA, DispatchType.LOADING, t("Carregando"), StateType.Local))
        request.data = { CampanhaID: campanhaId } as CampanhaPedidoResgateResponse;

        const asyncResponse = await _CampanhaPedidoResgateService.GetSolicitadosAprovadosByCampanha(request);

        if (ResponseValid(asyncResponse)) {
            const paged = (asyncResponse as PagedListResponse<CampanhaPedidoResgateResponse>)
            dispatch(DispatchPaged<CampanhaPedidoResgateResponse>(CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA, request, paged))
        } else {
            dispatch(DispatchLoading(CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA, DispatchType.ERROR, t("Erro"), StateType.Local))
        }
    }
}

export function ResetSolicitadosAprovadosByCampanha(request: PagedListRequest<CampanhaPedidoResgateResponse>, take:number): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchPagedReset<CampanhaPedidoResgateResponse>(CAMPANHA_PEDIDORESGATE_APROVADOS_GET_BY_CAMPANHA, request, take))
    }
}

export function AprovarResgate(campanhaPedidoResgateId: number, statusAtual: number, usuario: string, status: number): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(CAMPANHARESGATE_APROVAR, DispatchType.LOADING, 'Atualizando status...', StateType.Master))

        const asyncResponse = await _PedidoResgateService.AprovarPedido(campanhaPedidoResgateId, statusAtual, usuario, status)

        if (ResponseValid(asyncResponse)) {
            dispatch({
                payload: asyncResponse,
                type: CAMPANHARESGATE_APROVAR
            })
        } else {
            dispatch({
                payload: asyncResponse,
                type: CAMPANHARESGATE_APROVAR
            })
            dispatch(DispatchLoading(CAMPANHARESGATE_APROVAR, DispatchType.ERROR, "Erro ao mudar status!", StateType.Master))
        }
    }
}

export function ReprovarResgate(campanhaPedidoResgateId: number, motivo: string, usuario: string): AppThunk {
    return async (dispatch) => {
        dispatch(DispatchLoading(CAMPANHARESGATE_REPROVAR, DispatchType.LOADING))

        const asyncResponse = await _PedidoResgateService.ReprovarPedido(campanhaPedidoResgateId, motivo, usuario)

        if (ResponseValid(asyncResponse, false, dispatch)) {
            dispatch({
                payload: asyncResponse,
                type: CAMPANHARESGATE_REPROVAR
            })
            dispatch(DispatchLoading(CAMPANHARESGATE_REPROVAR, DispatchType.SUCCESS, "Resgate reprovado com sucesso!", StateType.Local))
        }
    }
}

export function ResgatesCheckout(data: PremiacaoResponse): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: data,
            type: SET_RESGATES_PAGAR
        })
    }
}

export function ResetResgatesCheckout(): AppThunk {
    return async (dispatch) => {
        dispatch({
            payload: undefined,
            type: RESET_RESGATES_PAGAR
        })
    }
}

export function removeResgate(id: number) {
    return {
        type: REMOVE_RESGATE,
        payload: id,
    };
}
